export const ITEMS_PER_SLIDE = {
  xs: 2,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 4,
} as const;

export const TESTIMONIAL_MIN_WIDTH = 300;
export const TESTIMONIAL_GAP = 16;
